import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, Router} from '@angular/router';
import {catchError, of} from 'rxjs';
import {map} from "rxjs/operators";
import {PurchaseOrderStore} from "../state/purchase-order.store";


export const purchaseOrderResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const purchaseOrderStore = inject(PurchaseOrderStore);

  const uuid = route.paramMap.get('uuid');
  if (!uuid) {
    void router.navigate(['/not-found']);
    return of(false);
  }

  return purchaseOrderStore.loadPurchaseOrderAndReturn(uuid).pipe(
    map(() => {
      return true;
    }),
    catchError((err) => {
      if (err.status === 404) {
        void router.navigate(['/not-found']);
      } else {
        void router.navigate(['/error']);
      }
      return of(false);
    })
  );
};
